import { useState, useEffect, useRef } from 'react';
import letter from './../assets/Letter.png';
import notes from './../assets/Notes.svg';
import cart from './../assets/Shopping-Cart.png';
import share from './../assets/Share.svg';
import info from './../assets/Info.svg';
import series from './../assets/Series.svg';
import ReadMoreText from './ReadMoreText';
import { getTranslations } from '../utils/translations';
import FullSermonView from './FullSermonView';
import { stripHtml } from '../utils/htmlUtils';

// Remove a single pair of surrounding quotes from a string (handles straight and curly quotes)
function stripSurroundingQuotes(str) {
    if (typeof str !== 'string') return str;
    const s = str.trim();
    const pairs = [
        ['"', '"'],
        ['\'', '\''],
        ['“', '”'],
        ['‘', '’']
    ];
    for (const [open, close] of pairs) {
        if (s.startsWith(open) && s.endsWith(close)) {
            return s.slice(open.length, s.length - close.length);
        }
    }
    return s;
}

function MessageLayout({ playlist, message }) {
    console.log('Rendering MessageLayout with ', message);
    const t = getTranslations();
    const playlistItem = message;
    console.log('Derived playlistItem as ', playlistItem);
    const isSeries = message?.playerType === "playlist" || message?.playerType === "single";

    const lang = window.broadcastPlayerData?.language || 'en-US';
    const isSpanish = lang.toLowerCase().startsWith('es');
    const isVPV = window.location.origin.includes('visionparavivir.org');
    const isVPVBranded = isSpanish || isVPV;
    
    let path = '';
    if (playlistItem?.seriesPage) {
        try {
            const url = new URL(playlistItem.seriesPage);
            path = url.pathname;
        } catch (error) {
            console.error('Invalid URL:', playlistItem.seriesPage, error);
            path = '';
        }
    }

    const fullMessageUrl = message?.messagePermalink;

    console.log('Full message URL:', fullMessageUrl);

    const messageSummaryDisplay = stripSurroundingQuotes(stripHtml(message?.messageSummary || ''));

    const [copyStatus, setCopyStatus] = useState('');
    const [showShareTutorial, setShowShareTutorial] = useState(false);
    const tutorialRef = useRef(null);

    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setCopyStatus(t.copied);
        } catch (err) {
            setCopyStatus(t.copyFailed);
            console.error('Error copying URL:', err);
        } finally {
            // Clear the status message after a few seconds
            setTimeout(() => setCopyStatus(''), 3000);
        }
    };

    const handleTutorialClick = () => {
        setShowShareTutorial(true);
    };

    const closeTutorial = () => {
        setShowShareTutorial(false);
    };

    // Close tutorial when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tutorialRef.current && !tutorialRef.current.contains(event.target)) {
                setShowShareTutorial(false);
            }
        };

        if (showShareTutorial) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [showShareTutorial]);

    return (
        <div id="media-container" style={{ backgroundColor: 'transparent' }}>
            <div className="content clearfix" style={{ backgroundColor: 'transparent', padding: '0px', clear: 'both', color: 'var(--vpv-text-color, #fff)' }}>
                <div id="message-layout" style={{ backgroundColor: 'transparent' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <a href={fullMessageUrl} title={message?.messageSpeaker === 'Paws & Tales' ? t.visitEpisodePage : (message?.mediaType === 'video' ? t.viewFullVideo : t.viewFullMessage)} rel="noreferrer">
                            <h2 style={{ color: !isVPVBranded ? '#fff !important' : 'var(--vpv-text-color, #fff) !important', textAlign: 'left' }}>{stripHtml(message?.name)}</h2>
                        </a> 
  
                        {window.location.href.includes('broadcasts/series-library/message') && (
                            <div style={{ position: 'relative' }}>
                                <span 
                                    title={t.howToShare}
                                    onClick={handleTutorialClick}
                                    style={{ 
                                        cursor: 'pointer', 
                                        marginLeft: '8px',
                                        fontSize: '16px',
                                        opacity: '0.8'
                                    }}
                                >
                                    <img src={info} style={{ width: '32px'}} alt="share" />
                                </span>
                                {showShareTutorial && (
                                    <div 
                                        ref={tutorialRef}
                                        style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: '0',
                                            backgroundColor: '#fff',
                                            color: '#333',
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            width: '280px',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                            zIndex: '1000',
                                            fontSize: '14px',
                                            lineHeight: '1.4'
                                        }}>
                                        <div style={{ 
                                            display: 'flex', 
                                            justifyContent: 'space-between', 
                                            alignItems: 'center',
                                            marginBottom: '12px'
                                        }}>
                                            <h4 style={{ margin: 0, color: '#212E60', fontSize: '16px' }}>{t.howToShare}</h4>
                                            <span 
                                                onClick={closeTutorial}
                                                style={{ 
                                                    cursor: 'pointer', 
                                                    fontSize: '18px',
                                                    color: '#999'
                                                }}
                                            >
                                                ×
                                            </span>
                                        </div>
                                        <ol style={{ margin: '0', paddingLeft: '18px' }}>
                                            <li style={{ marginBottom: '8px' }}>
                                                {t.shareStep1.replace('{type}', message?.mediaType === 'video' ? t.video.toLowerCase() : t.message.toLowerCase())}
                                            </li>
                                            <li style={{ marginBottom: '8px' }}>
                                                {t.shareStep2}
                                            </li>
                                            <li style={{ marginBottom: '0' }}>
                                                {t.shareStep3
                                                    .replace('{action}', message?.mediaType === 'video' ? t.watch : t.listen)
                                                    .replace('{type}', message?.mediaType === 'video' ? t.video.toLowerCase() : t.message.toLowerCase())}
                                            </li>
                                        </ol>
                                        <div style={{
                                            backgroundColor: '#f8f9fa',
                                            padding: '8px 12px',
                                            borderRadius: '4px',
                                            marginTop: '12px',
                                            fontSize: '12px',
                                            color: '#666'
                                        }}>
                                            {t.shareTip
                                                .replace('{itemType}', message?.messageSpeaker === 'Paws & Tales' ? (message?.seriesName === 'Original Song' ? t.song.toLowerCase() : t.episode.toLowerCase()) : (message?.mediaType === 'video' ? t.video.toLowerCase() : t.message.toLowerCase()))
                                                .replace('{containerType}', message?.messageSpeaker === 'Paws & Tales' ? t.fullSeason.toLowerCase() : t.series.toLowerCase())}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <p style={{ clear: 'left' }}>
                        <span>
                            {message?.messageSpeaker === 'Paws & Tales' 
                                ? (message?.seriesName === 'Original Song' ? t.song : t.episode) 
                                : (message?.mediaType === 'video' ? t.video : t.message)
                            } {message?.messageNumber}
                        </span>
                        {' '}- {message?.messageSpeaker}
                    </p>
                    {message?.messageSpeaker === 'Paws & Tales' && (
                        <p className="epSubTitle">
                            <a href={fullMessageUrl}>{t.toolsForParents}</a>
                            <br/>
                        </p>
                    )}
                    {isSeries && (
                        <div style={{ whiteSpace: 'pre-line' }}>
                            <ReadMoreText
                                key={message?.guid || message?.name}
                                text={messageSummaryDisplay}
                                seriesPage={message?.seriesPage || ""}
                                maxLength={240}
                                messageSpeaker={message?.messageSpeaker}
                                scriptureReference={message?.scriptureReference || ''}
                            />
                        </div>
                    )}
                    <div id="series-buttons" className="options" style={{ textAlign: 'left', marginTop: 0 }}>
                        {playlistItem?.notes && playlistItem.notes.includes('http') && (
                            <a id="cphPlayer_C001_LibraryDetail_Resources_lnkMessageMate" className="btn-header" style={{ backgroundColor: '#678cdf', '--vpv-btn-header-color': '#fff' }} data-toggle="tooltip" data-placement="top" title={t.downloadBibleStudy} data-original-title={t.downloadBibleStudy} href={playlistItem?.notes} target="_blank" rel="noreferrer"><img src={notes} alt="logo" style={{ filter: 'brightness(0) invert(1)' }} />{t.bibleStudy}</a>
                        )}
                        {playlistItem?.message && playlistItem.message.includes('http') && (
                            <a id="cphPlayer_C001_LibraryDetail_Resources_lnkBuyMessage" className="btn-header" style={{ backgroundColor: '#678cdf', '--vpv-btn-header-color': '#fff' }} data-toggle="tooltip" data-placement="top" title={message?.mediaType === 'video' ? t.buyVideo : t.buyMessage} data-original-title={message?.mediaType === 'video' ? t.buyVideo : t.buyMessage} href={playlistItem?.message} target="_blank" rel="noreferrer"><img src={cart} alt="logo" style={{ filter: 'brightness(0) invert(1)' }} />{message?.mediaType === 'video' ? t.video : t.message}</a>
                        )}
                        {playlistItem?.series && playlistItem.series.includes('http') && (
                            <a id="cphPlayer_C001_LibraryDetail_Resources_lnkBuySeries" className="btn-header" style={{ backgroundColor: '#678cdf', '--vpv-btn-header-color': '#fff' }} data-toggle="tooltip" data-placement="top" title={message?.messageSpeaker === 'Paws & Tales' ? t.buySeason : t.buySeries} data-original-title={message?.messageSpeaker === 'Paws & Tales' ? t.buySeason : t.buySeries} href={playlistItem?.series} target="_blank" rel="noreferrer"><img src={cart} alt="logo" style={{ filter: 'brightness(0) invert(1)' }} />{message?.messageSpeaker === 'Paws & Tales' ? t.fullSeason : t.fullSeries}</a>
                        )}
                    </div>
                    {copyStatus && <p style={{ fontSize: '12px', marginTop: '10px' }}>{copyStatus}</p>}
                </div>
            </div>
            <div id="series-subtitle" hidden style={{ display: 'none', color: 'var(--vpv-text-color, #000)', zIndex: 999 }}>
                    {message?.seriesSubtitle}
            </div>
        </div>
    );
}

export default MessageLayout;
